import type { SessionStatus } from '@features/customization-session/types';

import { StatusLabel } from '@shared/components/status-label';

import { getStatusStep } from '@features/customization-session/utils/session-status';

export const SessionStatusChip = ({ status }: { status: SessionStatus }) => {
  const { label, color } = getStatusStep(status);

  return (
    <StatusLabel className="h-6" color={color} variant="soft">
      {label}
    </StatusLabel>
  );
};
